<style scoped lang="scss">
.input-group-text.btn-secondary {
  background-color: $secondary;
}
</style>

<template>
  <div>
    <div class="row">
      <div class="col-3 pr-1 col-xl-2">
        <select class="form-control" v-model="dateObject.day">
          <option v-for="(option, index) in dayRange" :key="index">{{
            option
          }}</option>
        </select>
      </div>
      <div class="col-3 pl-1 pr-1 col-xl-2">
        <select class="form-control" v-model="dateObject.month">
          <option v-for="(option, index) in monthRange" :key="index">{{
            option
          }}</option>
        </select>
      </div>

      <div class="col-4 col-xl-3 pl-1">
        <select class="form-control" v-model="dateObject.year">
          <option v-for="(option, index) in yearRange" :key="index">{{
            option
          }}</option>
        </select>
      </div>
      <div v-if="hasRandomSelector" class="offset-xl-1"></div>
      <div v-if="hasRandomSelector" class="col-4">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              Zufall:
            </span>
          </div>
          <div>
            <select class="form-control h-100" v-model="age">
              <option v-for="(option, index) in ageRange" :key="index">{{
                option
              }}</option>
            </select>
          </div>
          <div class="input-group-append">
            <span
              @click="randomDate"
              class="input-group-text btn btn-secondary m-0"
            >
              <i class="fas fa-sync-alt"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="attribute.errors !== null"
      v-for="(error, index) in attribute.errors"
      :key="index"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
import { range } from 'lodash';
import moment from "moment";

export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      dateObject: {
        day: 1,
        month: 1,
        year: (new Date()).getFullYear() - 25
      },
      dayRange: range(1,32),
      monthRange: range(1,13),
      yearRange: range( (new Date()).getFullYear() - 125, (new Date()).getFullYear() - 17),
      age: 20,
      ageRange: range(18, 100),
      randomSelect: true,
    };
  },
  created() {
    if (this.value !== null) {
      const date = moment(this.value);
      this.dateObject.day = date.date();
      this.dateObject.month = date.month() + 1;
      this.dateObject.year = date.year();

      let ageDate = new Date(Date.now() - date.valueOf());
      this.age = Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    this.$emit('input', this.date);
  },
  methods: {
    randomDate() {
      const today = new Date();
      const date = new Date(
        today.getFullYear() - this.age - 1,
        today.getMonth() + Math.random() * 12,
        today.getDate() + Math.random() * 28,
      )

      this.dateObject.day = date.getDate();
      this.dateObject.month = date.getMonth() + 1;
      this.dateObject.year = date.getFullYear();
    }
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    type() {
      return this.attribute.type;
    },
    hasRandomSelector() {
      return Boolean(this.attribute.withRandomSelector);
    },
    date() {
      const date = `${this.dateObject.year}-${this.dateObject.month}-${this.dateObject.day}`;
      return date;
    }
  },
  watch: {
    dateObject: {
      handler: function  () {
        this.$emit('input', this.date);
      },
      deep: true
    }
  }
}
</script>
